'use client';

const CHUNK_RELOAD_KEY = 'chunk_error_reload';
const CHUNK_RELOAD_MAX_RETRIES = 1;

function isChunkLoadError(error: Error): boolean {
  return (
    error.name === 'ChunkLoadError' ||
    error.message.includes('Loading chunk') ||
    error.message.includes('Failed to load chunk')
  );
}

export default function GlobalError({ error }: Readonly<{ error: Error & { digest?: string }; reset: () => void }>) {
  if (globalThis.window !== undefined && isChunkLoadError(error)) {
    const reloadCount = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? '0');
    if (reloadCount < CHUNK_RELOAD_MAX_RETRIES) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, String(reloadCount + 1));
      globalThis.location.reload();
      return null;
    }
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  }

  return (
    <html lang="en">
      <body>
        <div style={{ margin: '1rem' }}>
          <h2 style={{ color: 'rgb(232, 59, 70)', fontSize: '2em' }}>An error occurred</h2>
          <p>
            The error has been reported to our support team. We will take a look at it and resolve the issue as soon as
            possible.
          </p>
          <button onClick={() => globalThis.location.reload()} type="button">
            Refresh
          </button>
        </div>
      </body>
    </html>
  );
}
